import type { ReactNode } from "react";
import { Box, Center } from "@chakra-ui/react";

type LayoutProps = {
  children: ReactNode;
};

export function Layout({ children }: LayoutProps) {
  return (
    <Box height="100vh" width="100vw">
      <Center height="100%" width="100%">
        {children}
      </Center>
    </Box>
  );
}
